<sol-dialog [dialog]="dialog$()" (action)="onAction($event)">
  @if (messages$().length > 0) {
    <sol-layout px="16" pt="16">
      <sol-alert [messages]="messages$()" />
    </sol-layout>
  }
  <div class="sol-dialog-content-message">
    {{ text$() | translate }}
  </div>
</sol-dialog>
